import { GetChat, PostChat, PutChat, DeleteChat } from "./apiServices";
import { networkUrls } from "./networkurls";

const base = networkUrls.chatSessions;

export interface ChatSessionDto {
  id: string;
  title: string;
  is_pinned: boolean;
  created_at: string;
  last_message_at: string;
}

export const createChatSession = (title = "New Chat") => PostChat(base, { title });

export const listChatSessions = () => GetChat(base);

export interface ChatMessageDto {
  id: string;
  role: "user" | "bot";
  content: any;
  created_at: string;
}

export interface ChatMessagesPageDto {
  messages: ChatMessageDto[];
  has_more: boolean;
}

export const getChatSessionMessages = (
  sessionId: string,
  options?: { limit?: number; before?: string }
) => {
  const params = new URLSearchParams();
  if (options?.limit) params.set("limit", String(options.limit));
  if (options?.before) params.set("before", options.before);
  const qs = params.toString();
  return GetChat(`${base}/${sessionId}/messages${qs ? `?${qs}` : ""}`);
};

export const saveChatMessage = (sessionId: string, role: "user" | "bot", content: any) =>
  PostChat(`${base}/${sessionId}/messages`, { role, content });

export const updateChatMessage = (sessionId: string, messageId: string, content: any) =>
  PutChat(`${base}/${sessionId}/messages/${messageId}`, { content });

export const renameChatSession = (sessionId: string, title: string) =>
  PutChat(`${base}/${sessionId}`, { title });

export const pinChatSession = (sessionId: string, isPinned: boolean) =>
  PutChat(`${base}/${sessionId}/pin`, { is_pinned: isPinned });

export const deleteChatSession = (sessionId: string) => DeleteChat(`${base}/${sessionId}`);
